const ErrorPage = () => {
    return <div>Error</div>;
};

export default ErrorPage;
